"use client"

import { useState, useContext, useEffect, useMemo, useRef, useCallback } from "react"
import { ErpContext } from "../../context/ErpContext.js"
import { DataGrid, GridToolbar } from "@mui/x-data-grid"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Button,
  Card,
  CardContent,
  Chip,
  alpha,
  Tooltip,
  Modal,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Badge,
  Autocomplete,
  Avatar,
  Divider,
  Alert,
  CircularProgress,
  Collapse,
  useMediaQuery,
  Checkbox,
  FormControlLabel,
} from "@mui/material"
import { ThemeProvider, createTheme } from "@mui/material/styles"
import GroupsIcon from "@mui/icons-material/Groups"
import BallotIcon from "@mui/icons-material/Ballot"
import SaveIcon from "@mui/icons-material/Save"
import AddIcon from "@mui/icons-material/Add"
import ScaleIcon from "@mui/icons-material/Scale"
import VisibilityIcon from "@mui/icons-material/Visibility"
import EditIcon from "@mui/icons-material/Edit"
import CloseIcon from "@mui/icons-material/Close"
import SearchIcon from "@mui/icons-material/Search"
import FilterListIcon from "@mui/icons-material/FilterList"
import ClearIcon from "@mui/icons-material/Clear"
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import TrendingUpIcon from "@mui/icons-material/TrendingUp"
import PercentIcon from "@mui/icons-material/Percent"
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn"
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import DeleteIcon from "@mui/icons-material/Delete"

import dayjs from "dayjs"
import Swal from "sweetalert2"
import CustomPagination from "../transaccionComponent/CustomPagination.js"
import RecetaComponent from "./RecetaComponent.js"
import GestionGenerarClientesPaquete from "../transaccionComponent/GestionGenerarClientesPaquete.js"

// Tema personalizado
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#5b5b5f",
    },
    secondary: {
      main: "#f4b10e",
    },
    success: {
      main: "#4CAF50",
    },
    error: {
      main: "#F44336",
    },
    warning: {
      main: "#FF8042",
    },
    info: {
      main: "#0088FE",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
          overflow: "visible",
        },
      },
    },
  },
})

const TablaReceta = () => {
  const {
    isNavbarCollapsed,
    getItemTresLetras,
    arrayItemTresLetras,
    itemTresLetras,
    itemAtributoNoEliminados,
    getItemAtributoNoEliminados,
    crearRecetaApi,
    eliminarBomApi,
    getRecetasViajes,
    getBomByIdItem,
    getListaMontosByIdItemIdEntidad,
    getEntidadFilterTipoEntidad,
    getUbicacion,
    ubicaciones,
    getItemUbicacionFilterByUbicacion,
    getFechaHoraActualClient,
    getItemUbicacionStatsBatch,
    getParametrosGlobales,
    getTablaRecetaDatos,
    getTablaRecetaTotales,
  } = useContext(ErpContext)
  const [recetas, setRecetas] = useState([])
  const [filteredRecetas, setFilteredRecetas] = useState([])
  const [loading, setLoading] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [selectedReceta, setSelectedReceta] = useState(null)
  const [editedIngredientes, setEditedIngredientes] = useState([])
  const [preciosCostos, setPreciosCostos] = useState({})
  const [precioPaquete, setPrecioPaquete] = useState(0)
  const [cargandoDatosModal, setCargandoDatosModal] = useState(false)
  
  // Estados para modal de pasajeros
  const [openModalPasajeros, setOpenModalPasajeros] = useState(false)
  const [recetaPasajeros, setRecetaPasajeros] = useState(null)
  const gestionPasajerosRef = useRef(null) // Ref para acceder a funciones del componente hijo

  const today = dayjs()
  // 🔧 ELIMINADO: Filtros de fecha inicio/fin - ya no se usan para filtrar
  // Las fechas inicio/fin se siguen mostrando en la tabla pero no filtran
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(100)
  const [totalPages, setTotalPages] = useState(0)
  const [totalCount, setTotalCount] = useState(0)
  const [montoTotalTransacciones, setMontoTotalTransacciones] = useState(0)
  // Estados para totales de todas las páginas
  const [totalPrecioTotal, setTotalPrecioTotal] = useState(0)
  const [totalCostoTotal, setTotalCostoTotal] = useState(0)
  const [totalGanancia, setTotalGanancia] = useState(0)
  const [loadingTotales, setLoadingTotales] = useState(false)
  const totalesReqIdRef = useRef(0)

  // Estados para filtros
  const [searchTextReceta, setSearchTextReceta] = useState("")
  const [filtroProducto, setFiltroProducto] = useState("")
  const [filtroDestino, setFiltroDestino] = useState("")

  const [recetaSelected, setRecetaSelected] = useState(null)
  const [destinoSelected, setDestinoSelected] = useState(null)
  
  // 🔧 NUEVO: Filtros por fecha de creación del paquete
  // Inicializar con los últimos 3 meses por defecto
  const [fechaCreacionDesde, setFechaCreacionDesde] = useState(today.subtract(3, "month"))
  const [fechaCreacionHasta, setFechaCreacionHasta] = useState(today)

  // 🔧 NUEVO: Estados para filtros de estado (cerrado/abierto)
  const [filtroCerrado, setFiltroCerrado] = useState(false)
  const [filtroAbierto, setFiltroAbierto] = useState(false)

  // Estado para modal de servicios
  const [modalServicios, setModalServicios] = useState({
    open: false,
    receta: null,
    servicios: []
  })
  const [paquetesOcultarCantidadFlag, setPaquetesOcultarCantidadFlag] = useState(null)
  const [modalEdicionRequiresRefetch, setModalEdicionRequiresRefetch] = useState(false)

  // Estado para modal de edición
  const [modalEdicion, setModalEdicion] = useState({
    open: false,
    paquete: null,
    ocultarCantidadYCostoXCantidad: null,
  })

  // Estado para modal de crear paquete
  const [openCrearPaqueteModal, setOpenCrearPaqueteModal] = useState(false)
  const [grupoSeleccionadoCrear, setGrupoSeleccionadoCrear] = useState(null) // ✅ Para mostrar el grupo seleccionado en el header

  // Estado para controlar visibilidad de filtros
  const isLaptopDown = useMediaQuery(theme.breakpoints.down("lg"))
  const [filtersOpen, setFiltersOpen] = useState(!isLaptopDown)
  
  // Ajustar filtersOpen cuando cambia el tamaño de pantalla
  useEffect(() => {
    setFiltersOpen(!isLaptopDown)
  }, [isLaptopDown])

  const ensurePaquetesOcultarCantidadFlag = useCallback(async () => {
    if (paquetesOcultarCantidadFlag !== null) {
      return paquetesOcultarCantidadFlag
    }

    if (typeof getParametrosGlobales !== "function") {
      setPaquetesOcultarCantidadFlag(false)
      return false
    }

    try {
      const res = await getParametrosGlobales(["paquetesOcultarCantidadYCostoXCantidad"])
      const raw = res?.paquetesOcultarCantidadYCostoXCantidad
      const parsed =
        raw === true || raw === 1 || raw === "1" || raw === "true" || raw === "TRUE"

      setPaquetesOcultarCantidadFlag(Boolean(parsed))
      return Boolean(parsed)
    } catch (error) {
      console.error("Error obteniendo parámetro paquetesOcultarCantidadYCostoXCantidad:", error)
      setPaquetesOcultarCantidadFlag(false)
      return false
    }
  }, [paquetesOcultarCantidadFlag, getParametrosGlobales])

  useEffect(() => {
    ensurePaquetesOcultarCantidadFlag()
  }, [ensurePaquetesOcultarCantidadFlag])

  // 🔧 ELIMINADO: Función para limpiar fechas de inicio (ya no se usa)
  // 🔧 ELIMINADO: Función buscarFechaInicioOptima (ya no se usa)

  useEffect(() => {
    const inicializar = async () => {
      // Inicializar fechas de creación con los últimos 3 meses
      const today = dayjs()
      const fechaDesde = today.subtract(3, "month")
      const fechaHasta = today
      
      setFechaCreacionDesde(fechaDesde)
      setFechaCreacionHasta(fechaHasta)
      
      await getUbicacion()
      await getItemAtributoNoEliminados()
      
      // Cargar datos iniciales con las fechas por defecto
      fetchData(null, null, null, 1, limit, fechaDesde, fechaHasta, null)
    }
    
    inicializar()
  }, [])

  // Efecto para búsqueda de ítems
  useEffect(() => {
    if (searchTextReceta.length >= 3) {
      arrayItemTresLetras([])
      getItemTresLetras(searchTextReceta)
    }
  }, [searchTextReceta])

  // 🔧 ELIMINADO: Efecto para actualizar endDate (ya no se usa)

  // ✅ OPTIMIZADO: Función para generar etiqueta de ítem con useCallback
  const generateRecetaLabel = useCallback((item) => {
    const activeAttributes = itemAtributoNoEliminados.filter((attr) => !attr.eliminado)

    const attributeValues = activeAttributes
      .map((attr, index) => {
        const attributeValue = item[`itemDatoAtributo${index + 1}`]
        return attributeValue ? attributeValue : ""
      })
      .join(" ")

    return `${item.codigo} - ${item.descripcion} ${attributeValues} ${item.codigoScanner}`
  }, [itemAtributoNoEliminados])

  // Función para manejar cambio de ítem
  const handleRecetaChange = (event, newValue) => {
    setRecetaSelected(newValue)
    if (newValue) {
      const defaultValues = itemAtributoNoEliminados.map((attr, index) => ({
        value: newValue[`itemDatoAtributo${index + 1}`] || "",
      }))
    }
  }

  const handleDestinoChange = (event, newValue) => {
    setDestinoSelected(newValue)
  }

  // Funciones para modal de servicios
  const handleOpenModalServicios = (receta) => {
    setModalServicios({
      open: true,
      receta: receta,
      servicios: receta.ingredientes || []
    })
  }

  const handleCloseModalServicios = () => {
    setModalServicios({
      open: false,
      receta: null,
      servicios: []
    })
  }

  // Funciones para modal de edición
  const handleOpenModalEdicion = async (receta) => {
    const ocultarFlagPromise = ensurePaquetesOcultarCantidadFlag()
    // Cargar el item completo si no está en itemTresLetras
    const itemExistente = itemTresLetras?.find(it => it.id === receta.idProductoTerminado)
    if (!itemExistente && receta.codigoProductoTerminado) {
      // Buscar el item por código para obtener los atributos
      await getItemTresLetras(receta.codigoProductoTerminado.substring(0, 3))
    }
    
    // Asegurar que los atributos estén cargados
    if (!itemAtributoNoEliminados || itemAtributoNoEliminados.length === 0) {
      await getItemAtributoNoEliminados()
    }
    
    const ocultarFlag = await ocultarFlagPromise

    setModalEdicion({
      open: true,
      paquete: receta,
      ocultarCantidadYCostoXCantidad: ocultarFlag,
    })
    setModalEdicionRequiresRefetch(false)
  }

  const handleCloseModalEdicion = ({ forceRefetch = false } = {}) => {
    setModalEdicion({
      open: false,
      paquete: null,
      ocultarCantidadYCostoXCantidad: null,
    })
    const shouldRefetch = forceRefetch || modalEdicionRequiresRefetch
    setModalEdicionRequiresRefetch(false)
    if (!shouldRefetch) return

    const idReceta = recetaSelected ? recetaSelected.id : null
    const idDestino = destinoSelected ? destinoSelected.id : null
    let cerradoParam = null
    if (filtroCerrado) {
      cerradoParam = true
    } else if (filtroAbierto) {
      cerradoParam = false
    }

    fetchData(
      idReceta,
      null,
      idDestino,
      page,
      limit,
      fechaCreacionDesde,
      fechaCreacionHasta,
      cerradoParam
    )
  }

  const handleRecetaGuardada = () => {
    setModalEdicionRequiresRefetch(true)
    handleCloseModalEdicion({ forceRefetch: true })
  }

  const handleOpenCrearPaqueteModal = async () => {
    await ensurePaquetesOcultarCantidadFlag()
    setOpenCrearPaqueteModal(true)
  }

  const handleCloseCrearPaqueteModal = () => {
    setOpenCrearPaqueteModal(false)
    setGrupoSeleccionadoCrear(null) // ✅ Resetear el grupo seleccionado al cerrar
  }

  // Función para eliminar paquete
  const handleEliminarPaquete = async (receta) => {
    try {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: `¿Deseas eliminar el paquete "${receta.descripcionProductoTerminado}" del destino "${receta.destino}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      })

      if (result.isConfirmed) {
        setLoading(true)
        // Usar idPaquete si está disponible (más preciso), sino usar idProductoTerminado + destinoId
        await eliminarBomApi(receta.idProductoTerminado, receta.destinoId, receta.idPaquete || null)
        
        await Swal.fire({
          title: '¡Eliminado!',
          text: 'El paquete ha sido eliminado correctamente.',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        })

        // Recargar datos de la tabla
        const idReceta = recetaSelected ? recetaSelected.id : null
        const idDestino = destinoSelected ? destinoSelected.id : null
        fetchData(idReceta, null, idDestino, page, limit, fechaCreacionDesde, fechaCreacionHasta)
      }
    } catch (error) {
      console.error("Error al eliminar paquete:", error)
      await Swal.fire({
        title: 'Error',
        text: error.response?.data?.message || 'Error al eliminar el paquete',
        icon: 'error',
        confirmButtonText: 'Aceptar'
      })
    } finally {
      setLoading(false)
    }
  }

  const handlePaqueteCreado = () => {
    // Cerrar el modal
    setOpenCrearPaqueteModal(false)
    // Refrescar la tabla después de crear el paquete
    const idReceta = recetaSelected ? recetaSelected.id : null
    const idDestino = destinoSelected ? destinoSelected.id : null
    fetchData(idReceta, null, idDestino, page, limit)
  }

  // 🔧 FUNCIÓN PARA FORMATEAR MONEDA ARGENTINA
  const formatearMoneda = (valor) => {
    if (typeof valor !== 'number' || isNaN(valor)) return '$0'
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(valor)
  }

  // ✅ OPTIMIZADO: Generar atributos como subtexto con useCallback
  const generarAtributosSubtexto = useCallback((item) => {
    if (!item || !itemAtributoNoEliminados) return ""
    
    const activeAttributes = itemAtributoNoEliminados.filter((attr) => !attr.eliminado)
    const attributeValues = activeAttributes
      .map((attr, index) => {
        const attributeValue = item[`itemDatoAtributo${index + 1}`]
        return attributeValue ? attributeValue : ""
      })
      .filter((value) => value !== "" && value !== "undefined")
      .join(" • ")
    
    return attributeValues
  }, [itemAtributoNoEliminados])

  // ✅ OPTIMIZADO: Generar color gradiente con useCallback
  const generarColorGradiente = useCallback((porcentaje) => {
    // Normalizar el porcentaje entre 0 y 100
    const porcentajeNormalizado = Math.max(0, Math.min(100, porcentaje))
    
    // Definir colores del gradiente
    const colores = {
      muyBajo: '#ff4444',    // Rojo - Pérdida o muy baja ganancia
      bajo: '#ff8800',       // Naranja - Ganancia baja
      medio: '#ffcc00',      // Amarillo - Ganancia media
      bueno: '#88cc00',      // Verde claro - Buena ganancia
      excelente: '#44aa44'   // Verde - Excelente ganancia
    }
    
    // Definir rangos de porcentaje
    if (porcentajeNormalizado < 0) return colores.muyBajo
    if (porcentajeNormalizado < 10) return colores.bajo
    if (porcentajeNormalizado < 20) return colores.medio
    if (porcentajeNormalizado < 30) return colores.bueno
    return colores.excelente
  }, [])

  const fetchInitialData = async () => {
    try {
      await getItemAtributoNoEliminados()
    } catch (error) {}
  }

  // ✅ OPTIMIZADO: Crear caché compartido a nivel de componente para persistir entre renders
  const cacheMontos = useRef({})
  
  // ✅ OPTIMIZADO: Función para cargar datos financieros con caché mejorado
  const cargarDatosFinancieros = useCallback(async (recetas) => {
    try {
      // 🔧 PASAJEROS CONFIRMADOS (viaja=true, liberado=false) por (idItem, idUbicacion) en batch
      let statsByKey = {}
      try {
        const pairs = (recetas || [])
          .map((r) => ({ idItem: r.idProductoTerminado, idUbicacion: r.destinoId }))
          .filter((p) => Number.isFinite(Number(p.idItem)) && Number.isFinite(Number(p.idUbicacion)))
        if (pairs.length > 0) {
          //console.log("🔍 TABLA - Cargando pasajeros confirmados (batch):", pairs)
          statsByKey = (await getItemUbicacionStatsBatch(pairs)) || {}
          //console.log("🔍 TABLA - Pasajeros confirmados cargados:", statsByKey)
        }
      } catch (e) {
        console.warn("No fue posible obtener pasajeros confirmados (batch):", e?.message || e)
        statsByKey = {}
      }

      // Obtener entidades una sola vez
      const [clientes, proveedores] = await Promise.all([
        getEntidadFilterTipoEntidad(1), // Clientes
        getEntidadFilterTipoEntidad(2)  // Proveedores
      ])

      if (!clientes || !proveedores || clientes.length === 0 || proveedores.length === 0) {
        console.warn("No se encontraron entidades para cálculos financieros")
        return recetas
      }

      const primerCliente = clientes[0]
      const primerProveedor = proveedores[0]

      // Truncado a 2 decimales sin redondear (para igualar backend/modal)
      const trunc2 = (n) => Math.trunc((Number(n) || 0) * 100) / 100

      // ✅ OPTIMIZADO: Usar caché persistente del useRef
      const obtenerMontoCacheado = async (idEntidad, idItem, idUbicacion) => {
        const key = `${idEntidad}-${idItem}-${idUbicacion}`
        
        // Si ya está en caché, retornar inmediatamente
        if (cacheMontos.current[key] !== undefined) {
          return cacheMontos.current[key]
        }
        
        // Si no está en caché, hacer la petición HTTP
        try {
          const data = await getListaMontosByIdItemIdEntidad(idEntidad, idItem, idUbicacion)
          const monto = data?.monto ? Number.parseFloat(data.monto) : 0
          cacheMontos.current[key] = monto
          return monto
        } catch (error) {
          // Cachear como 0 para evitar reintentos en caso de error 404
          cacheMontos.current[key] = 0
          return 0
        }
      }

      // Procesar cada receta
      const recetasConFinancieros = await Promise.all(
        recetas.map(async (receta) => {
          let precioPaquete = 0
          let costoTotalServicios = 0
          let pasajeros = 0

          try {
            // Pasajeros confirmados = viaja=true y liberado=false (desde stats batch)
            const key = `${receta.idProductoTerminado}-${receta.destinoId}`
            pasajeros = Number(statsByKey?.[key]?.pasajerosConfirmados || 0)

            // 1. Obtener precio del paquete (cliente - tipo 1) - CON CACHÉ
            precioPaquete = await obtenerMontoCacheado(1, receta.idProductoTerminado, receta.destinoId)

            // 2. Calcular costo total de servicios (proveedor - tipo 2) - CON CACHÉ
            if (receta.ingredientes && receta.ingredientes.length > 0) {
              costoTotalServicios = 0
              
              //console.log(`🔍 TABLA - Cargando costos para ${receta.descripcionProductoTerminado}:`)
              //console.log(`   destinoId: ${receta.destinoId}`)
              //console.log(`   # servicios: ${receta.ingredientes.length}`)
              
              for (const servicio of receta.ingredientes) {
                // Usar caché para evitar peticiones duplicadas
                const costo = await obtenerMontoCacheado(2, servicio.idMateriaPrima, receta.destinoId)
                const cantidad = Number.parseFloat(servicio.cantidad || 0)
                //console.log(`   - Servicio ${servicio.idMateriaPrima}: cantidad=${cantidad}, costo=${costo}, subtotal=${cantidad * costo}`)
                costoTotalServicios += (cantidad * costo)
              }
              
              //console.log(`   TOTAL TABLA: ${costoTotalServicios}`)
            }

            // 3. Calcular ganancia y porcentaje
            const precioPorPasajeros = trunc2(precioPaquete * pasajeros)
            const ganancia = trunc2(precioPorPasajeros - costoTotalServicios)
            const porcentajeGanancia = precioPorPasajeros > 0 ? (ganancia / precioPorPasajeros) * 100 : 0

            return {
              ...receta,
              precioPaquete,
              costoTotalServicios,
              ganancia,
              porcentajeGanancia,
              pasajeros,
              precioPorPasajeros
            }
          } catch (error) {
            console.error(`Error cargando datos financieros para receta ${receta.id}:`, error)
            return {
              ...receta,
              precioPaquete: 0,
              costoTotalServicios: 0,
              ganancia: 0,
              porcentajeGanancia: 0,
              pasajeros: 0,
              precioPorPasajeros: 0
            }
          }
        })
      )

      //console.log(`✅ Total de peticiones HTTP únicas realizadas: ${Object.keys(cacheMontos.current).length}`)
      return recetasConFinancieros
    } catch (error) {
      console.error("Error cargando datos financieros:", error)
      return recetas
    }
  }, [getItemUbicacionStatsBatch, getEntidadFilterTipoEntidad, getListaMontosByIdItemIdEntidad])

  // ✅ OPTIMIZADO: Calcular totales con useCallback
  const calcularTotalesTodasLasPaginas = useCallback(async (idReceta, idMateriaPrima, idDestino, startDate, endDate, fechaCreacionDesde, fechaCreacionHasta, cerrado = null, reqId = null) => {
    try {
      const response = await getTablaRecetaTotales(
        startDate,
        endDate,
        idReceta,
        idMateriaPrima,
        idDestino,
        fechaCreacionDesde,
        fechaCreacionHasta,
        cerrado
      )

      const sumaPrecioTotal = Number(response?.totalPrecioTotal || 0)
      const sumaCostoTotal = Number(response?.totalCostoTotal || 0)
      const sumaGanancia = Number(response?.totalGanancia || 0)

      // Evitar que una respuesta vieja pise a una nueva
      if (reqId !== null && reqId !== totalesReqIdRef.current) return

      setTotalPrecioTotal(sumaPrecioTotal)
      setTotalCostoTotal(sumaCostoTotal)
      setTotalGanancia(sumaGanancia)
    } catch (error) {
      console.error("Error calculando totales:", error)
      if (reqId !== null && reqId !== totalesReqIdRef.current) return
      setTotalPrecioTotal(0)
      setTotalCostoTotal(0)
      setTotalGanancia(0)
    } finally {
      if (reqId !== null && reqId !== totalesReqIdRef.current) return
      setLoadingTotales(false)
    }
  }, [getTablaRecetaTotales])

  // ✅ OPTIMIZADO: fetchData con useCallback
  const fetchData = useCallback(async (idReceta, idMateriaPrima, idDestino, page, limit = 100, fechaCreacionDesde = null, fechaCreacionHasta = null, cerrado = null) => {
    try {
      setLoading(true)

      // 🔧 ELIMINADO: Filtros de fecha inicio/fin del paquete (ya no se usan para filtrar)
      // Solo se filtran por fechas de creación del registro

      // 🔧 FECHAS DE CREACIÓN: Normalizar si existen
      let dateCreacionDesde = null
      let dateCreacionHasta = null
      
      if (fechaCreacionDesde) {
        const formattedCreacionDesde = fechaCreacionDesde.format("YYYY-MM-DD")
        const resultCreacionDesde = await getFechaHoraActualClient(formattedCreacionDesde)
        dateCreacionDesde = dayjs(resultCreacionDesde.fechaServidor).startOf("day").toDate()
      }
      
      if (fechaCreacionHasta) {
        const formattedCreacionHasta = fechaCreacionHasta.format("YYYY-MM-DD")
        const resultCreacionHasta = await getFechaHoraActualClient(formattedCreacionHasta)
        dateCreacionHasta = dayjs(resultCreacionHasta.fechaServidor).endOf("day").toDate()
      }

      // Enviar Date objects al backend (null para fechas de inicio/fin del paquete)
      const response = await getTablaRecetaDatos(
        null, // startDate - ya no se filtra por fecha inicio del paquete
        null, // endDate - ya no se filtra por fecha fin del paquete
        idReceta,
        idMateriaPrima,
        idDestino,
        page,
        limit,
        dateCreacionDesde,
        dateCreacionHasta,
        cerrado
      )

      //console.log("Recetas obtenidas:", response)

      let recetasData = []
      // Actualizar estados de paginación si la respuesta tiene estructura de paginación
      if (response.data) {
        setTotalPages(response.totalPages || 0)
        setTotalCount(response.total || 0)
        recetasData = response.data
      } else {
        // Si la respuesta es directamente un array
        recetasData = response
      }

      // Cargar itemTresLetras para los grupos únicos de las recetas
      const gruposUnicos = [...new Set(recetasData.map(r => r.codigoProductoTerminado).filter(Boolean))]
      for (const codigo of gruposUnicos) {
        if (codigo && codigo.length >= 3) {
          await getItemTresLetras(codigo.substring(0, 3))
        }
      }

      const recetasTransformadas = transformarRecetas(recetasData)
      setFilteredRecetas(recetasTransformadas)
      setRecetas(recetasTransformadas)
      
      // Calcular totales de todas las páginas (en background, no bloquea la UI)
      const reqId = ++totalesReqIdRef.current
      setLoadingTotales(true)
      calcularTotalesTodasLasPaginas(
        idReceta,
        idMateriaPrima,
        idDestino,
        null, // startDate - ya no se filtra
        null, // endDate - ya no se filtra
        dateCreacionDesde,
        dateCreacionHasta,
        cerrado,
        reqId
      )
    } catch (error) {
      console.error("Error fetching recetas:", error)
    } finally {
      setLoading(false)
    }
  }, [
    getFechaHoraActualClient, getTablaRecetaDatos,
    calcularTotalesTodasLasPaginas
  ])

  // ✅ OPTIMIZADO: transformarRecetas con useCallback
  const transformarRecetas = useCallback((recetasData) => {
    return recetasData.map((receta) => {
      const totalIngredientes = receta.ingredientes?.length || 0
      const cantidadTotal = receta.ingredientes?.reduce((sum, ing) => sum + (ing.cantidad || 0), 0) || 0

      // Obtener nombres de ingredientes para búsqueda
      const nombresIngredientes =
        receta.ingredientes?.map((ing) => ing.materiaPrima?.descripcion || "").join(", ") || ""

      return {
        id: receta.id,
        idPaquete: receta.idPaquete || receta.id, // ID del paquete (cabecera)
        descripcionProductoTerminado: receta.descripcionProductoTerminado || "Sin descripción",
        codigoProductoTerminado: receta.codigoProductoTerminado || "Sin código",
        idProductoTerminado: receta.idProductoTerminado,
        destino: receta.ubicacion?.descripcion || "Sin destino",
        destinoId: receta.destino || receta.destinoId, // ID del destino para cálculos
        fechaInicio: receta.fechaInicio ? dayjs(receta.fechaInicio).format("DD/MM/YYYY") : "N/A",
        fechaFin: receta.fechaFin ? dayjs(receta.fechaFin).format("DD/MM/YYYY") : "N/A",
        noches: receta.noches || 0,
        cerrado: receta.cerrado || false, // Estado del paquete
        idVendedor: receta.idVendedor || null, // Vendedor del paquete
        vendedor: receta.vendedor || null, // Info del vendedor
        totalIngredientes,
        cantidadTotal: cantidadTotal.toFixed(2),
        ingredientes: receta.ingredientes || [],
        nombresIngredientes,
        // Agregar fechas formateadas
        fechaCreacion: receta.createdAt ? dayjs(receta.createdAt).format("DD/MM/YYYY") : "N/A",
        fechaActualizacion: receta.updatedAt ? dayjs(receta.updatedAt).format("DD/MM/YYYY") : "N/A",
        horaCreacion: receta.createdAt ? dayjs(receta.createdAt).format("HH:mm") : "N/A",
        horaActualizacion: receta.updatedAt ? dayjs(receta.updatedAt).format("HH:mm") : "N/A",
        // Para mostrar el primer ingrediente como referencia
        primerIngrediente: receta.ingredientes?.[0]?.materiaPrima?.descripcion || "Sin ingredientes",
        codigoPrimerIngrediente: receta.ingredientes?.[0]?.materiaPrima?.codigo || "",
        // Campos financieros (vienen precalculados desde backend)
        precioPaquete: Number(receta.precioPaquete || 0),
        costoTotalServicios: Number(receta.costoTotalServicios || 0),
        ganancia: Number(receta.ganancia || 0),
        porcentajeGanancia: Number(receta.porcentajeGanancia || 0),
        pasajeros: Number(receta.pasajeros || 0),
        precioPorPasajeros: Number(receta.precioPorPasajeros || 0),
      }
    })
  }, [])

  // ✅ OPTIMIZADO: Función para cargar precios y costos con useCallback (MOVIDA ANTES DE handleOpenModal)
  const cargarPreciosCostos = useCallback(async (receta) => {
    try {
      // Cargar entidades una sola vez
      const [clientes, proveedores] = await Promise.all([
        getEntidadFilterTipoEntidad(1),
        getEntidadFilterTipoEntidad(2)
      ])

      // Cargar precio del paquete
      if (clientes && clientes.length > 0) {
        const precioData = await getListaMontosByIdItemIdEntidad(
          1, //clientes[0].id, 
          receta.idProductoTerminado, 
          receta.destino
        )
        if (precioData && precioData.monto) {
          setPrecioPaquete(Number.parseFloat(precioData.monto))
        }
      }

      // Cargar costos de servicios en paralelo
      if (proveedores && proveedores.length > 0) {
        //console.log(`🔍 MODAL - Cargando costos para ${receta.descripcionProductoTerminado || receta.descripcion}:`)
        //console.log(`   destino: ${receta.destino}`)
        //console.log(`   # servicios: ${receta.ingredientes.length}`)
        
        const costosPromises = receta.ingredientes.map(async (servicio) => {
          const key = `${servicio.idMateriaPrima}-${receta.destino}`
          try {
            const costoData = await getListaMontosByIdItemIdEntidad(
              proveedores[0].id, 
              servicio.idMateriaPrima, 
              receta.destino
            )
            const costo = costoData?.monto ? Number.parseFloat(costoData.monto) : 0
            //console.log(`   - Servicio ${servicio.idMateriaPrima}: costo=${costo}`)
            return {
              key,
              costo,
              idEntidadCosto: proveedores[0].id,
            }
          } catch (error) {
            //console.log(`Error cargando costo para servicio ${servicio.idMateriaPrima}:`, error)
            return { key, costo: 0, idEntidadCosto: null }
          }
        })

        const costosResultados = await Promise.all(costosPromises)
        const nuevosPreciosCostos = {}
        costosResultados.forEach(({ key, costo, idEntidadCosto }) => {
          nuevosPreciosCostos[key] = { costo, idEntidadCosto }
        })
        
        //console.log(`   Costos cargados en modal:`, nuevosPreciosCostos)
        
        setPreciosCostos(nuevosPreciosCostos)
      }
    } catch (error) {
      console.error("Error cargando precios y costos:", error)
    }
  }, [getEntidadFilterTipoEntidad, getListaMontosByIdItemIdEntidad])

  const handleOpenModal = useCallback(async (receta) => {
    setSelectedReceta(receta)
    setEditedIngredientes(receta.ingredientes.map((ing) => ({ ...ing }))) // Copia profunda
    
    // Cargar precios y costos de forma asíncrona para no bloquear la UI
    setOpenModal(true)
    
    // Cargar datos en background
    setCargandoDatosModal(true)
    setTimeout(async () => {
      await cargarPreciosCostos(receta)
      setCargandoDatosModal(false)
    }, 100)
  }, [cargarPreciosCostos])

  const handleCloseModal = useCallback(() => {
    setOpenModal(false)
    setSelectedReceta(null)
    setEditedIngredientes([])
    setPreciosCostos({})
    setPrecioPaquete(0)
    setCargandoDatosModal(false)
  }, [])

  // ✅ OPTIMIZADO: Funciones para modal de pasajeros con useCallback
  const handleOpenModalPasajeros = useCallback((receta) => {
    //console.log("📋 Abriendo modal de pasajeros para receta:", receta)
    // Nota: si el paquete está cerrado se abre igual, pero en modo solo lectura (ver prop soloLectura).
    
    // Buscar el item completo en itemTresLetras para obtener atributos
    const itemCompleto = itemTresLetras?.find(it => it.id === receta.idProductoTerminado)
    
    // Formatear atributos como se hace en GestionGenerarClientesPaquete
    let attributeValues = ""
    if (itemCompleto && itemAtributoNoEliminados) {
      const activeAttributes = itemAtributoNoEliminados.filter((attr) => !attr.eliminado)
      attributeValues = activeAttributes
        .map((attr, index) => {
          const attributeValue = itemCompleto[`itemDatoAtributo${index + 1}`]
          return attributeValue ? attributeValue : ""
        })
        .filter((val) => val.trim() !== "")
        .join(" ")
    }
    
    // Formatear receta con el objeto grupo correctamente estructurado
    const recetaFormateada = {
      ...receta,
      grupoFormateado: {
        id: receta.idProductoTerminado,
        idItem: receta.idProductoTerminado,
        descripcion: receta.productoTerminado || itemCompleto?.descripcion || "",
        codigo: receta.codigoProductoTerminado || itemCompleto?.codigo || "",
        label: `${receta.codigoProductoTerminado || itemCompleto?.codigo || ""} - ${receta.productoTerminado || itemCompleto?.descripcion || ""}${attributeValues ? " - " + attributeValues : ""}`,
        atributos: attributeValues,
      },
      destinoFormateado: ubicaciones?.find(ub => ub.id === receta.destinoId) ? {
        id: receta.destinoId,
        label: ubicaciones.find(ub => ub.id === receta.destinoId)?.descripcion || receta.destino,
      } : {
        id: receta.destinoId,
        label: receta.destino || "",
      }
    }
    
    setRecetaPasajeros(recetaFormateada)
    setOpenModalPasajeros(true)
  }, [itemTresLetras, itemAtributoNoEliminados, ubicaciones])

  const handleCloseModalPasajeros = useCallback(async () => {
    // Verificar si hay cambios pendientes antes de cerrar
    if (gestionPasajerosRef.current && gestionPasajerosRef.current.hayCambiosPendientes()) {
      const result = await Swal.fire({
        title: '¿Desea guardar los cambios?',
        text: 'Tiene cambios pendientes que no se han guardado. ¿Desea guardarlos antes de cerrar?',
        icon: 'question',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#6c757d',
        denyButtonColor: '#d33',
        confirmButtonText: 'Sí, guardar',
        denyButtonText: 'No guardar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          container: 'swal-z-index-high'
        },
        didOpen: () => {
          // Asegurar z-index alto para que esté por encima del modal de pasajeros
          const swalContainer = document.querySelector('.swal2-container')
          if (swalContainer) {
            swalContainer.style.zIndex = '9999'
          }
        }
      })

      if (result.isConfirmed) {
        // Si el usuario confirma, guardar los cambios
        try {
          await gestionPasajerosRef.current.guardarCambios()
          // Esperar un momento para que se complete el guardado
          await new Promise(resolve => setTimeout(resolve, 500))
          // Cerrar el modal después de guardar y recargar datos
          setOpenModalPasajeros(false)
          setRecetaPasajeros(null)
          // Recargar datos de la tabla
          const idReceta = recetaSelected ? recetaSelected.id : null
          const idDestino = destinoSelected ? destinoSelected.id : null
          fetchData(idReceta, null, idDestino, page, limit, fechaCreacionDesde, fechaCreacionHasta)
        } catch (error) {
          console.error("Error al guardar cambios:", error)
          await Swal.fire({
            title: 'Error',
            text: 'No se pudieron guardar los cambios. Por favor, intente nuevamente.',
            icon: 'error',
            confirmButtonText: 'Aceptar',
            customClass: {
              container: 'swal-z-index-high'
            },
            didOpen: () => {
              const swalContainer = document.querySelector('.swal2-container')
              if (swalContainer) {
                swalContainer.style.zIndex = '9999'
              }
            }
          })
          // No cerrar el modal si hay error
        }
      } else if (result.isDenied) {
        // Si el usuario elige "No guardar", cerrar sin guardar
        setOpenModalPasajeros(false)
        setRecetaPasajeros(null)
      }
      // Si cancela (result.isDismissed), no hacer nada (mantener el modal abierto)
    } else {
      // No hay cambios pendientes, cerrar normalmente
      setOpenModalPasajeros(false)
      setRecetaPasajeros(null)
    }
  }, [recetaSelected, destinoSelected, page, limit, fechaCreacionDesde, fechaCreacionHasta, fetchData])

  const handleCantidadChange = useCallback((index, newCantidad) => {
    const updated = [...editedIngredientes]
    updated[index] = {
      ...updated[index],
      cantidad: Number.parseFloat(newCantidad) || 0,
    }
    setEditedIngredientes(updated)
  }, [editedIngredientes])

  const handleSaveChanges = useCallback(async () => {
  //console.log("Receta seleccionada", selectedReceta);
  //console.log("Guardando cambios:", editedIngredientes);

  try {
    setLoading(true);

    const ingredientesConCantidad = editedIngredientes.map((item) => {
      return {
        idItem: item.idMateriaPrima,
        cantidad: item.cantidad || "0",
        idUbicacion: item.idUbicacion || 1,
      };
    });

    const idProductoTerminado = selectedReceta.id;
    //console.log("ID Producto Terminado:", idProductoTerminado);
    //console.log("Ingredientes con cantidad:", ingredientesConCantidad);
    await crearRecetaApi(idProductoTerminado, ingredientesConCantidad, true);

  } catch (error) {
    console.error("Error creando o actualizando receta:", error);
  } finally {
    setLoading(false);
    handleCloseModal();
    const idReceta = recetaSelected ? recetaSelected.id : null
    fetchData(idReceta, null, null, page, limit)
  }
  }, [editedIngredientes, selectedReceta, crearRecetaApi, handleCloseModal, recetaSelected, fetchData, page, limit])

  const limpiarFiltros = useCallback(() => {
    setSearchTextReceta("")
    setRecetaSelected(null)
    setDestinoSelected(null)
    setFiltroProducto("")
    setFiltroDestino("")
    const today = dayjs()
    // Reinicializar fechas de creación con los últimos 3 meses
    setFechaCreacionDesde(today.subtract(3, "month"))
    setFechaCreacionHasta(today)
    // Limpiar filtros de estado
    setFiltroCerrado(false)
    setFiltroAbierto(false)
  }, [])

  const aplicarFiltros = useCallback(() => {
    //console.log(recetaSelected)
    const idReceta = recetaSelected ? recetaSelected.id : null
    const idDestino = destinoSelected ? destinoSelected.id : null
    // Determinar el valor de cerrado según los checkboxes
    let cerradoParam = null
    if (filtroCerrado) {
      cerradoParam = true
    } else if (filtroAbierto) {
      cerradoParam = false
    }
    // Al aplicar filtros, volver a la página 1
    setPage(1)
    fetchData(idReceta, null, idDestino, 1, limit, fechaCreacionDesde, fechaCreacionHasta, cerradoParam)
  }, [recetaSelected, destinoSelected, filtroCerrado, filtroAbierto, limit, fechaCreacionDesde, fechaCreacionHasta, fetchData])

  // 🔧 Manejar cambio de checkbox Cerrado (mutuamente excluyente)
  const handleFiltroCerradoChange = useCallback((event) => {
    const checked = event.target.checked
    if (checked) {
      setFiltroCerrado(true)
      setFiltroAbierto(false) // Deseleccionar el otro
    } else {
      setFiltroCerrado(false) // Si se deselecciona el mismo, simplemente deseleccionar
    }
  }, [])

  // 🔧 Manejar cambio de checkbox Abierto (mutuamente excluyente)
  const handleFiltroAbiertoChange = useCallback((event) => {
    const checked = event.target.checked
    if (checked) {
      setFiltroAbierto(true)
      setFiltroCerrado(false) // Deseleccionar el otro
    } else {
      setFiltroAbierto(false) // Si se deselecciona el mismo, simplemente deseleccionar
    }
  }, [])

  const hayFiltrosActivos = searchTextReceta || recetaSelected || destinoSelected || fechaCreacionDesde || fechaCreacionHasta || filtroCerrado || filtroAbierto

  // 🔧 CÁLCULOS FINANCIEROS
  const calcularCostoTotal = useMemo(() => {
    return editedIngredientes.reduce((total, servicio) => {
      const key = `${servicio.idMateriaPrima}-${selectedReceta?.destino}`
      const cantidad = Number.parseFloat(servicio.cantidad || 0)
      const costo = preciosCostos[key]?.costo || 0
      return total + (cantidad * costo)
    }, 0)
  }, [editedIngredientes, preciosCostos, selectedReceta?.destino])

  const calcularGanancia = useMemo(() => {
    return precioPaquete - calcularCostoTotal
  }, [precioPaquete, calcularCostoTotal])

  const calcularMargenGanancia = useMemo(() => {
    if (precioPaquete === 0) return 0
    return (calcularGanancia / precioPaquete) * 100
  }, [calcularGanancia, precioPaquete])

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 0.2,
      minWidth: 80,
      headerAlign: "center",
      hide: true, // 🔧 OCULTAR COLUMNA ID (clave compuesta)
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          ID
        </Typography>
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Chip label={params.value} size="small" color="primary" variant="outlined" sx={{ fontWeight: 600 }} />
        </Box>
      ),
    },
    {
      field: "fechaCreacion",
      headerName: "Fecha",
      flex: 0.35,
      minWidth: 110,
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          Fecha
        </Typography>
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <CalendarTodayIcon fontSize="small" sx={{ color: theme.palette.info.main }} />
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: "codigoProductoTerminado",
      headerName: "Grupo",
      flex: 0.3,
      minWidth: 120,
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          Grupo
        </Typography>
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <Chip label={params.value} size="small" color="secondary" variant="filled" sx={{ fontWeight: 600 }} />
        </Box>
      ),
    },
    {
      field: "destino",
      headerName: "Destino",
      flex: 0.6,
      minWidth: 150,
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          Destino
        </Typography>
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <LocationOnIcon fontSize="small" sx={{ color: theme.palette.secondary.main }} />
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: "fechaInicio",
      headerName: "Fecha Inicio",
      flex: 0.4,
      minWidth: 120,
      headerAlign: "center",
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          F. Inicio
        </Typography>
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <CalendarTodayIcon fontSize="small" sx={{ color: theme.palette.primary.main }} />
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: "fechaFin",
      headerName: "Fecha Fin",
      flex: 0.4,
      minWidth: 120,
      headerAlign: "center",
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          F. Fin
        </Typography>
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <CalendarTodayIcon fontSize="small" sx={{ color: theme.palette.warning.main }} />
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: "cerrado",
      headerName: "Estado",
      flex: 0.35,
      minWidth: 120,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          Estado
        </Typography>
      ),
      renderCell: (params) => {
        const esCerrado = params.value === true
        return (
          <Chip
            label={esCerrado ? "Cerrado" : "Abierto"}
            size="small"
            color={esCerrado ? "success" : "warning"}
            variant={esCerrado ? "filled" : "outlined"}
            sx={{ fontWeight: 700 }}
          />
        )
      },
    },
    {
      field: "noches",
      headerName: "Noches",
      flex: 0.25,
      minWidth: 90,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          Noches
        </Typography>
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Chip 
            label={params.value || 0} 
            size="small" 
            color="secondary" 
            variant="outlined" 
            sx={{ fontWeight: 600 }} 
          />
        </Box>
      ),
    },
    {
      field: "totalIngredientes",
      headerName: "Servicios",
      flex: 0.3,
      minWidth: 120,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          Servicios
        </Typography>
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Tooltip 
            title={
              params.value > 0 
                ? `Click para ver ${params.value} servicio${params.value > 1 ? 's' : ''}`
                : "No hay servicios asociados"
            }
          >
            <Box
              onClick={() => params.value > 0 && handleOpenModalServicios(params.row)}
              sx={{
                cursor: params.value > 0 ? "pointer" : "default",
                "&:hover": params.value > 0 ? {
                  transform: "scale(1.05)",
                  transition: "transform 0.2s ease"
                } : {}
              }}
            >
              <Badge badgeContent={params.value} color="info">
                <BallotIcon fontSize="small" sx={{ color: theme.palette.warning.main }} />
              </Badge>
            </Box>
          </Tooltip>
        </Box>
      ),
    },
    {
      field: "pasajeros",
      headerName: "Pasajeros",
      flex: 0.3,
      minWidth: 120,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          Pasajeros
        </Typography>
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
          }}
        >
          <GroupsIcon fontSize="small" sx={{ color: theme.palette.info.main }} />
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {params.value || 0}
          </Typography>
        </Box>
      ),
    },
    {
      field: "precioPorPasajeros",
      headerName: "Precio Total",
      flex: 0.4,
      minWidth: 120,
      headerAlign: "right",
      align: "right",
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          Precio Total
        </Typography>
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 1,
          }}
        >
          <MonetizationOnIcon fontSize="small" sx={{ color: theme.palette.success.main }} />
          <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.success.main }}>
            {formatearMoneda(params.value || 0)}
          </Typography>
        </Box>
      ),
    },
    {
      field: "costoTotalServicios",
      headerName: "Costo Total",
      flex: 0.4,
      minWidth: 120,
      headerAlign: "right",
      align: "right",
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          Costo Total
        </Typography>
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 1,
          }}
        >
          <AttachMoneyIcon fontSize="small" sx={{ color: theme.palette.warning.main }} />
          <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.warning.main }}>
            {formatearMoneda(params.value)}
          </Typography>
        </Box>
      ),
    },
    {
      field: "ganancia",
      headerName: "Ganancia",
      flex: 0.4,
      minWidth: 120,
      headerAlign: "right",
      align: "right",
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          Ganancia
        </Typography>
      ),
      renderCell: (params) => {
        const ganancia = params.value || 0
        const color = ganancia >= 0 ? theme.palette.info.main : theme.palette.error.main
        return (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 1,
            }}
          >
            <AccountBalanceWalletIcon fontSize="small" sx={{ color }} />
            <Typography variant="body2" sx={{ fontWeight: 600, color }}>
              {formatearMoneda(ganancia)}
            </Typography>
          </Box>
        )
      },
    },
    {
      field: "porcentajeGanancia",
      headerName: "% Ganancia",
      flex: 0.4,
      minWidth: 120,
      headerAlign: "center",
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          % Ganancia
        </Typography>
      ),
      renderCell: (params) => {
        const porcentaje = params.value || 0
        const colorGradiente = generarColorGradiente(porcentaje)
        return (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
              backgroundColor: colorGradiente,
              borderRadius: 2,
              px: 1.5,
              py: 0.5,
              minWidth: 80,
            }}
          >
            <PercentIcon fontSize="small" sx={{ color: "white" }} />
            <Typography 
              variant="body2" 
              sx={{ 
                fontWeight: 700, 
                color: "white",
                textShadow: "0 1px 2px rgba(0,0,0,0.3)"
              }}
            >
              {porcentaje.toFixed(1)}%
            </Typography>
          </Box>
        )
      },
    },
   
    {
      field: "fechaActualizacion",
      headerName: "Fecha Actualización",
      flex: 0.3,
      minWidth: 130,
      hide: true,
      headerAlign: "center",
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          F. Actualización
        </Typography>
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "0.8rem" }}>
            {params.value}
          </Typography>
          <Typography variant="caption" sx={{ color: "text.secondary", fontSize: "0.7rem" }}>
            {params.row.horaActualizacion}
          </Typography>
        </Box>
      ),
    },
    {
      field: "acciones",
      headerName: "Acciones",
      flex: 0.3,
      minWidth: 150,
      headerAlign: "center",
      sortable: false,
      renderHeader: () => (
        <Typography variant="subtitle2" sx={{ color: "white", fontWeight: "bold" }}>
          Acciones
        </Typography>
      ),
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1, width: "100%", overflow: "visible" }}>
          <Tooltip title="Editar Paquete">
            <IconButton
              size="small"
              onClick={() => handleOpenModalEdicion(params.row)}
              sx={{
                bgcolor: alpha(theme.palette.secondary.main, 0.1),
                "&:hover": {
                  bgcolor: alpha(theme.palette.secondary.main, 0.2),
                  transform: "scale(1.1)",
                },
                transition: "all 0.2s ease",
              }}
            >
              <EditIcon fontSize="small" sx={{ color: theme.palette.secondary.main }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Editar Pasajeros">
            <IconButton
              size="small"
              onClick={() => handleOpenModalPasajeros(params.row)}
              sx={{
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                "&:hover": {
                  bgcolor: alpha(theme.palette.primary.main, 0.2),
                  transform: "scale(1.1)",
                },
                transition: "all 0.2s ease",
              }}
            >
              <GroupsIcon fontSize="small" sx={{ color: theme.palette.primary.main }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar Paquete">
            <IconButton
              size="small"
              onClick={() => handleEliminarPaquete(params.row)}
              sx={{
                bgcolor: alpha(theme.palette.error.main, 0.1),
                "&:hover": {
                  bgcolor: alpha(theme.palette.error.main, 0.2),
                  transform: "scale(1.1)",
                },
                transition: "all 0.2s ease",
              }}
            >
              <DeleteIcon fontSize="small" sx={{ color: theme.palette.error.main }} />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ]

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          width: "100%",
          overflow: "hidden",
          position: "relative",
          backgroundColor: "#f8f9fa",
          boxSizing: "border-box",
        }}
      >
        {/* Barra compacta para Laptop/Mobile: botón de Filtros + acciones clave */}
        {isLaptopDown && (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1,
              px: 1,
              pt: 1,
            }}
          >
            <Button
              variant="outlined"
              size="small"
              startIcon={<FilterListIcon />}
              onClick={() => setFiltersOpen((v) => !v)}
              sx={{ textTransform: "none" }}
            >
              {filtersOpen ? "Ocultar filtros" : "Mostrar filtros"}
            </Button>

            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="contained"
                size="small"
                onClick={aplicarFiltros}
                startIcon={<SearchIcon />}
                sx={{
                  backgroundColor: "#5b5b5f",
                  textTransform: "none",
                  color: "white",
                  "&:hover": { backgroundColor: alpha("#5b5b5f", 0.9) },
                }}
              >
                Buscar
              </Button>
              <Tooltip title="Crear nuevo paquete">
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={handleOpenCrearPaqueteModal}
                  sx={{
                    textTransform: "none",
                    backgroundColor: "#5b5b5f",
                    "&:hover": { backgroundColor: alpha("#5b5b5f", 0.8) },
                  }}
                >
                  Crear
                </Button>
              </Tooltip>
            </Box>
          </Box>
        )}

        {/* Contenedor de filtros (siempre visible en Desktop; colapsable en Laptop/Mobile) */}
        <Collapse in={filtersOpen || !isLaptopDown} timeout={250} unmountOnExit>
          <Box sx={{ p: 1, flexShrink: 0 }}>
            <Paper sx={{ 
              p: 2, 
              borderRadius: 2, 
              mb: 2, 
              backgroundColor: alpha(theme.palette.background.paper, 0.9),
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}>
              {/* Encabezado en una sola fila (desktop). En pantallas chicas puede envolver. */}
              <Grid container spacing={1.5} alignItems="center" wrap="wrap">
                {/* Fecha Creación (Desde - Hasta) */}
                <Grid item xs={12} md={4}>
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={fechaCreacionDesde}
                        onChange={(newValue) => setFechaCreacionDesde(newValue)}
                        format="DD/MM/YYYY"
                        label="Creación Desde"
                        slotProps={{
                          textField: { size: "small", fullWidth: true },
                        }}
                      />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={fechaCreacionHasta}
                        onChange={(newValue) => setFechaCreacionHasta(newValue)}
                        format="DD/MM/YYYY"
                        label="Creación Hasta"
                        slotProps={{
                          textField: { size: "small", fullWidth: true },
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>

                {/* Buscar Grupo */}
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    disablePortal
                    options={(itemTresLetras || []).map((it) => ({
                      label: generateRecetaLabel(it),
                      descripcion: it.descripcion,
                      codigo: it.codigo,
                      id: it.id,
                      codigoScanner: it.codigoScanner,
                    }))}
                    value={recetaSelected}
                    onChange={handleRecetaChange}
                    onInputChange={(event, newInputValue) => setSearchTextReceta(newInputValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Buscar Grupo"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <SearchIcon color="action" sx={{ ml: 0.5, mr: 0 }} fontSize="small" />
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>

                {/* Buscar Destino */}
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    disablePortal
                    options={(ubicaciones || []).map((ubicacion) => ({
                      label: ubicacion.descripcion,
                      id: ubicacion.id,
                      descripcion: ubicacion.descripcion,
                    }))}
                    value={destinoSelected}
                    onChange={handleDestinoChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Buscar Destino"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <LocationOnIcon color="action" sx={{ ml: 0.5, mr: 0 }} fontSize="small" />
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>

                {/* Acciones: Buscar + Limpiar (ícono) + Crear Paquete */}
                <Grid item xs={12} md={2}>
                  <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end", alignItems: "center" }}>
                    <Button
                      variant="contained"
                      onClick={aplicarFiltros}
                      startIcon={<SearchIcon />}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        backgroundColor: "#5b5b5f",
                        px: 2,
                        "&:hover": {
                          backgroundColor: alpha("#5b5b5f", 0.9),
                        },
                      }}
                    >
                      Buscar
                    </Button>

                    <Tooltip title="Limpiar filtros">
                      <span>
                        <IconButton
                          onClick={limpiarFiltros}
                          disabled={!hayFiltrosActivos}
                          size="small"
                          sx={{
                            borderRadius: 2,
                            border: `1px solid ${alpha(theme.palette.divider, 0.6)}`,
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>

                    <Tooltip title="Crear nuevo paquete">
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={handleOpenCrearPaqueteModal}
                        sx={{
                          textTransform: "none",
                          backgroundColor: "#5b5b5f",
                          borderRadius: 2,
                          "&:hover": {
                            backgroundColor: alpha("#5b5b5f", 0.8),
                          },
                        }}
                      >
                        Crear
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              </Grid>
        </Paper>

        {/* 🔧 Checkboxes de filtro por estado (Cerrado/Abierto) */}
        <Box sx={{ px: 1, pb: 1 }}>
          <Paper sx={{ 
            p: 1.5, 
            borderRadius: 2, 
            backgroundColor: alpha(theme.palette.background.paper, 0.9),
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}>
            <Box sx={{ display: "flex", gap: 3, alignItems: "center", flexWrap: "wrap" }}>
              <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.text.secondary }}>
                Filtrar por estado:
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={filtroCerrado}
                    onChange={handleFiltroCerradoChange}
                    size="small"
                    sx={{
                      color: theme.palette.success.main,
                      "&.Mui-checked": {
                        color: theme.palette.success.main,
                      },
                    }}
                  />
                }
                label={
                  <Chip
                    label="Cerrado"
                    size="small"
                    color="success"
                    variant={filtroCerrado ? "filled" : "outlined"}
                    sx={{ fontWeight: 600 }}
                  />
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={filtroAbierto}
                    onChange={handleFiltroAbiertoChange}
                    size="small"
                    sx={{
                      color: theme.palette.warning.main,
                      "&.Mui-checked": {
                        color: theme.palette.warning.main,
                      },
                    }}
                  />
                }
                label={
                  <Chip
                    label="Abierto"
                    size="small"
                    color="warning"
                    variant={filtroAbierto ? "filled" : "outlined"}
                    sx={{ fontWeight: 600 }}
                  />
                }
              />
            </Box>
          </Paper>
        </Box>
        </Box>
        </Collapse>

        {/* Tabla */}
        <Paper
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            m: 1,
            mt: 0,
            borderRadius: 3,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            position: "relative",
          }}
        >
          <DataGrid
            key={isNavbarCollapsed ? "collapsed" : "expanded"}
            rows={filteredRecetas}
            columns={columns}
            getRowId={(row) => row.id}
            pageSize={25}
            rowsPerPageOptions={[10, 25, 50]}
            disableSelectionOnClick
            loading={loading}
            density="compact"
            getRowHeight={() => 34}
            columnHeaderHeight={40}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  id: false,
                  fechaActualizacion: false,
                },
              },
            }}
            components={{
              Toolbar: GridToolbar,
            }}
            componentsProps={{
              toolbar: {
                showQuickFilter: false,
              },
            }}
            className="tablaVentasDataGrid"
            sx={{
              width: "100%",
              border: 0,
              height: "100%",
              minWidth: 0,
              "& .MuiDataGrid-footerContainer": {
                display: "none !important",
              },
              "& .MuiDataGrid-columnHeaders": {
                //MANEJA CSS HEADER
                backgroundColor: "#5b5b5f",
                color: "white",
                borderBottom: "2px solid #333",
                height: "40px !important",
                minHeight: "40px !important",
                maxHeight: "40px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                //MANEJA CSS HEADER
                height: "40px !important",
                minHeight: "40px !important",
                maxHeight: "40px !important",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                //MANEJA CSS HEADER
                color: "white !important",
                lineHeight: "40px !important",
                fontSize: "0.8rem",
                fontWeight: 700,
              },
              "& .MuiDataGrid-columnHeaderTitle .MuiDataGrid-menuIconButton": {
                color: "white !important",
              },
              "& .MuiDataGrid-menuIconButton": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiInputBase-root": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiTablePagination-root": {
                color: "black !important",
              },
              "& .MuiSelect-icon": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #ccc",
                display: "flex",
                alignItems: "center",
                px: 1,
                py: 0,
                fontSize: "0.82rem",
              },
              "& .MuiDataGrid-cellContent": {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              "& .MuiDataGrid-cell[data-field='acciones']": {
                overflow: "visible !important",
                "& .MuiDataGrid-cellContent": {
                  overflow: "visible !important",
                  textOverflow: "clip",
                  whiteSpace: "normal",
                },
              },
              "& .MuiDataGrid-row": {
                "&:nth-of-type(even)": {
                  backgroundColor: "#F7F7F7",
                },
                "&:hover": {
                  backgroundColor: "#E3EAFD !important",
                  transition: "background 0.3s ease",
                },
              },
              "& .row-devolucion": {
                backgroundColor: alpha("#9e9e9e !important", 0.05),
                "&:hover": {
                  backgroundColor: alpha("#9e9e9e !important", 0.1),
                },
              },
              "& .MuiDataGrid-virtualScroller": {
                lineHeight: "none !important",
                height: "10px !imporant",
              },
              "& .MuiDataGrid-footerContainer": {
                position: "sticky",
                bottom: 0,
                backgroundColor: "#ffffff",
                borderTop: "1px solid #ddd",
                zIndex: 10,
              },
              "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                width: "2px",
              },
              "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "10px",
              },
            }}
          />
        </Paper>

        {/* Footer (paginación) */}
        <Box sx={{ flexShrink: 0, p: 1 }}>
          <CustomPagination
            currentPage={page}
            totalPages={totalPages}
            totalCount={totalCount}
            montoTotalTransacciones={montoTotalTransacciones}
            vieneDe={"tablaRecetas"}
            onPageChange={(newPage) => {
              const safeTotalPages = Math.max(Number(totalPages) || 1, 1)
              const nextPage = Math.min(Math.max(Number(newPage) || 1, 1), safeTotalPages)

              const idReceta = recetaSelected ? recetaSelected.id : null
              const idDestino = destinoSelected ? destinoSelected.id : null
              let cerradoParam = null
              if (filtroCerrado) cerradoParam = true
              else if (filtroAbierto) cerradoParam = false

              setPage(nextPage)
              fetchData(
                idReceta,
                null,
                idDestino,
                nextPage,
                limit,
                fechaCreacionDesde,
                fechaCreacionHasta,
                cerradoParam
              )
            }}
            totalPrecioTotal={totalPrecioTotal}
            totalCostoTotal={totalCostoTotal}
            totalGanancia={totalGanancia}
            loadingTotales={loadingTotales}
          />
        </Box>

        {/* Modal mejorado sutilmente */}
        <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-receta-titulo">
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "95%", md: "85%", lg: "75%" },
              maxWidth: 1000,
              maxHeight: "90vh",
              bgcolor: "background.paper",
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
              borderRadius: 3,
              overflow: "hidden",
            }}
          >
            {/* Header del modal mejorado */}
            <Box
              sx={{
                p: 3,
                backgroundColor: "#5b5b5f",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    bgcolor: "rgba(255,255,255,0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <GroupsIcon sx={{ fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                    Detalle de Grupo - Servicios
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    {selectedReceta?.descripcionProductoTerminado} • ID: {selectedReceta?.id}
                  </Typography>
                </Box>
              </Box>
              <IconButton
                onClick={handleCloseModal}
                sx={{
                  color: "white",
                  bgcolor: "rgba(255,255,255,0.1)",
                  "&:hover": {
                    bgcolor: "rgba(255,255,255,0.2)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Contenido del modal */}
            <Box sx={{ p: 3, maxHeight: "calc(90vh - 120px)", overflowY: "auto" }}>
              {selectedReceta && (
                <>
                  {/* Indicador de carga */}
                  {cargandoDatosModal && (
                    <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                      <CircularProgress size={24} />
                      <Typography variant="body2" sx={{ ml: 1 }}>
                        Cargando datos financieros...
                      </Typography>
                    </Box>
                  )}

                  {/* Información general mejorada */}
                  <Grid container spacing={3} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={2.4}>
                      <Paper
                        sx={{
                          p: 2.5,
                          textAlign: "center",
                          backgroundColor: alpha(theme.palette.primary.main, 0.05),
                          border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                        }}
                      >
                        <BallotIcon sx={{ fontSize: 32, color: theme.palette.primary.main, mb: 1 }} />
                        <Typography variant="h5" color="primary" sx={{ fontWeight: 700, mb: 0.5 }}>
                          {selectedReceta.totalIngredientes}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Total Servicios
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={2.4}>
                      <Paper
                        sx={{
                          p: 2.5,
                          textAlign: "center",
                          backgroundColor: alpha(theme.palette.success.main, 0.05),
                          border: `1px solid ${alpha(theme.palette.success.main, 0.1)}`,
                        }}
                      >
                        <MonetizationOnIcon sx={{ fontSize: 32, color: theme.palette.success.main, mb: 1 }} />
                        <Typography variant="h5" color="success.main" sx={{ fontWeight: 700, mb: 0.5 }}>
                          {formatearMoneda(precioPaquete)}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Precio del Paquete
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={2.4}>
                      <Paper
                        sx={{
                          p: 2.5,
                          textAlign: "center",
                          backgroundColor: alpha(theme.palette.warning.main, 0.05),
                          border: `1px solid ${alpha(theme.palette.warning.main, 0.1)}`,
                        }}
                      >
                        <AttachMoneyIcon sx={{ fontSize: 32, color: theme.palette.warning.main, mb: 1 }} />
                        <Typography variant="h5" color="warning.main" sx={{ fontWeight: 700, mb: 0.5 }}>
                          {formatearMoneda(calcularCostoTotal)}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Costo Total
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={2.4}>
                      <Paper
                        sx={{
                          p: 2.5,
                          textAlign: "center",
                          backgroundColor: alpha(theme.palette.info.main, 0.05),
                          border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
                        }}
                      >
                        <AccountBalanceWalletIcon sx={{ fontSize: 32, color: theme.palette.info.main, mb: 1 }} />
                        <Typography variant="h5" color="info.main" sx={{ fontWeight: 700, mb: 0.5 }}>
                          {formatearMoneda(calcularGanancia)}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Ganancia
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={2.4}>
                      <Paper
                        sx={{
                          p: 2.5,
                          textAlign: "center",
                          backgroundColor: alpha(theme.palette.secondary.main, 0.05),
                          border: `1px solid ${alpha(theme.palette.secondary.main, 0.1)}`,
                        }}
                      >
                        <PercentIcon sx={{ fontSize: 32, color: theme.palette.secondary.main, mb: 1 }} />
                        <Typography variant="h5" color="secondary.main" sx={{ fontWeight: 700, mb: 0.5 }}>
                          {calcularMargenGanancia.toFixed(1)}%
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Margen
                        </Typography>
                      </Paper>
                    </Grid>
                  </Grid>

                  {/* Tabla de ingredientes */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                      <EditIcon color="primary" />
                      Servicios del Grupo
                    </Typography>

                    <TableContainer
                      component={Paper}
                      sx={{
                        borderRadius: 2,
                        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                      }}
                    >
                      <Table size="small">
                        <TableHead>
                          <TableRow sx={{ backgroundColor: alpha(theme.palette.primary.main, 0.1) }}>
                            <TableCell sx={{ fontWeight: 600 }}>ID</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Código</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Descripción</TableCell>
                            <TableCell sx={{ fontWeight: 600, textAlign: "center" }}>Cantidad</TableCell>
                            <TableCell sx={{ fontWeight: 600, textAlign: "center" }}>Costo Unit.</TableCell>
                            <TableCell sx={{ fontWeight: 600, textAlign: "center" }}>Subtotal</TableCell>
                            <TableCell sx={{ fontWeight: 600, textAlign: "center" }}>Estado</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {editedIngredientes.map((ingrediente, index) => {
                            const key = `${ingrediente.idMateriaPrima}-${selectedReceta?.destino}`
                            const costoUnitario = preciosCostos[key]?.costo || 0
                            const subtotal = Number.parseFloat(ingrediente.cantidad || 0) * costoUnitario
                            
                            return (
                              <TableRow
                                key={ingrediente.idMateriaPrima}
                                sx={{
                                  "&:hover": {
                                    backgroundColor: alpha(theme.palette.primary.main, 0.02),
                                  },
                                  "&:nth-of-type(even)": {
                                    backgroundColor: alpha(theme.palette.grey[50], 0.5),
                                  },
                                }}
                              >
                                <TableCell>
                                  <Chip
                                    label={ingrediente.idMateriaPrima}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                  />
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontFamily: "monospace",
                                      fontWeight: 500,
                                      bgcolor: alpha(theme.palette.secondary.main, 0.1),
                                      px: 1,
                                      py: 0.5,
                                      borderRadius: 1,
                                      display: "inline-block",
                                    }}
                                  >
                                    {ingrediente.materiaPrima?.codigo || "N/A"}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <BallotIcon fontSize="small" sx={{ color: theme.palette.info.main }} />
                                    <Box>
                                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                        {ingrediente.materiaPrima?.descripcion || "Sin descripción"}
                                      </Typography>
                                      {generarAtributosSubtexto(ingrediente.materiaPrima) && (
                                        <Typography
                                          variant="caption"
                                          color="text.secondary"
                                          sx={{
                                            display: "block", 
                                            mt: 0.5, 
                                            fontStyle: "italic",
                                            opacity: 0.7,
                                          }}
                                        >
                                          {generarAtributosSubtexto(ingrediente.materiaPrima)}
                                        </Typography>
                                      )}
                                    </Box>
                                  </Box>
                                </TableCell>
                                <TableCell sx={{ textAlign: "center" }}>
                                  <TextField
                                    size="small"
                                    type="number"
                                    value={ingrediente.cantidad === 0 ? "" : ingrediente.cantidad}
                                    onChange={(e) => {
                                      const value = e.target.value
                                      if (value === "") {
                                        handleCantidadChange(index, 0)
                                      } else {
                                        handleCantidadChange(index, value)
                                      }
                                    }}
                                    inputProps={{
                                      step: "0.01",
                                      min: "0",
                                    }}
                                    sx={{
                                      width: 130,
                                      "& .MuiOutlinedInput-root": {
                                        borderRadius: 2,
                                      },
                                    }}
                                  />
                                </TableCell>
                                <TableCell sx={{ textAlign: "center" }}>
                                  <Typography variant="body2" color="warning.main" sx={{ fontWeight: 600 }}>
                                    {formatearMoneda(costoUnitario)}
                                  </Typography>
                                </TableCell>
                                <TableCell sx={{ textAlign: "center" }}>
                                  <Typography variant="body2" color="error.main" sx={{ fontWeight: 600 }}>
                                    {formatearMoneda(subtotal)}
                                  </Typography>
                                </TableCell>
                                <TableCell sx={{ textAlign: "center" }}>
                                  <Chip
                                    label={ingrediente.eliminado ? "Eliminado" : "Activo"}
                                    size="small"
                                    color={ingrediente.eliminado ? "error" : "success"}
                                    variant={ingrediente.eliminado ? "filled" : "outlined"}
                                    sx={{ fontWeight: 600 }}
                                  />
                                </TableCell>
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>

                  {/* Resumen financiero */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                      <TrendingUpIcon color="primary" />
                      Resumen Financiero
                    </Typography>
                    
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={4}>
                        <Paper
                          sx={{
                            p: 2,
                            textAlign: "center",
                            backgroundColor: alpha(theme.palette.success.main, 0.05),
                            border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
                          }}
                        >
                          <Typography variant="h6" color="success.main" sx={{ fontWeight: 700 }}>
                            {formatearMoneda(precioPaquete)}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Precio del Paquete
                          </Typography>
                        </Paper>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Paper
                          sx={{
                            p: 2,
                            textAlign: "center",
                            backgroundColor: alpha(theme.palette.warning.main, 0.05),
                            border: `1px solid ${alpha(theme.palette.warning.main, 0.2)}`,
                          }}
                        >
                          <Typography variant="h6" color="warning.main" sx={{ fontWeight: 700 }}>
                            {formatearMoneda(calcularCostoTotal)}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Costo Total
                          </Typography>
                        </Paper>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Paper
                          sx={{
                            p: 2,
                            textAlign: "center",
                            backgroundColor: alpha(theme.palette.info.main, 0.05),
                            border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
                          }}
                        >
                          <Typography variant="h6" color="info.main" sx={{ fontWeight: 700 }}>
                            {formatearMoneda(calcularGanancia)} ({calcularMargenGanancia.toFixed(1)}%)
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Ganancia y Margen
                          </Typography>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Box>

                  {/* Alertas de rentabilidad */}
                  {calcularMargenGanancia < 15 && (
                    <Alert severity="warning" sx={{ mb: 2, borderRadius: 2 }}>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        ⚠️ Margen de ganancia bajo ({calcularMargenGanancia.toFixed(1)}%)
                      </Typography>
                      <Typography variant="caption">
                        Considera aumentar el precio de venta o reducir costos para mejorar la rentabilidad.
                      </Typography>
                    </Alert>
                  )}

                  {calcularGanancia < 0 && (
                    <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        ❌ Pérdida por unidad ({formatearMoneda(Math.abs(calcularGanancia))})
                      </Typography>
                      <Typography variant="caption">
                        El precio de venta es menor que el costo. Ajusta los precios urgentemente.
                      </Typography>
                    </Alert>
                  )}

                  {/* Botones de acción */}
                  <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, pt: 2 }}>
                    <Button
                      variant="outlined"
                      onClick={handleCloseModal}
                      startIcon={<CloseIcon />}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        px: 3,
                      }}
                    >
                      Cancelar
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleSaveChanges}
                      startIcon={<SaveIcon />}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        backgroundColor: "#5b5b5f",
                        px: 3,
                        "&:hover": {
                          backgroundColor: alpha("#5b5b5f", 0.9),
                        },
                      }}
                    >
                      Guardar Cambios
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Modal>

        {/* Modal para mostrar servicios del paquete */}
        <Modal
          open={modalServicios.open}
          onClose={handleCloseModalServicios}
          aria-labelledby="modal-servicios-titulo"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "95%", md: "70%", lg: "60%" },
              maxWidth: 800,
              maxHeight: "85vh",
              bgcolor: "background.paper",
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
              borderRadius: 3,
              overflow: "hidden",
            }}
          >
            {/* Header del modal */}
            <Box
              sx={{
                p: 3,
                backgroundColor: theme.palette.warning.main,
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    bgcolor: "rgba(255,255,255,0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <BallotIcon sx={{ fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                    Servicios del Paquete
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    {modalServicios.receta?.descripcionProductoTerminado}
                  </Typography>
                </Box>
              </Box>
              <IconButton
                onClick={handleCloseModalServicios}
                sx={{
                  color: "white",
                  bgcolor: "rgba(255,255,255,0.1)",
                  "&:hover": {
                    bgcolor: "rgba(255,255,255,0.2)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Contenido del modal */}
            <Box sx={{ p: 3, maxHeight: "calc(85vh - 140px)", overflowY: "auto" }}>
              {modalServicios.servicios.length === 0 ? (
                <Box sx={{ textAlign: "center", py: 4 }}>
                  <BallotIcon sx={{ fontSize: 48, color: "#ccc", mb: 2 }} />
                  <Typography variant="h6" color="text.secondary">
                    No hay servicios asociados a este paquete
                  </Typography>
                </Box>
              ) : (
                <TableContainer
                  component={Paper}
                  sx={{
                    borderRadius: 2,
                    border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                  }}
                >
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: alpha(theme.palette.warning.main, 0.1) }}>
                        <TableCell sx={{ fontWeight: 600 }}>Descripción</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Nombre</TableCell>
                        <TableCell sx={{ fontWeight: 600, textAlign: "center" }}>Cantidad</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {modalServicios.servicios.map((servicio, index) => (
                        <TableRow
                          key={servicio.idMateriaPrima}
                          sx={{
                            "&:hover": {
                              backgroundColor: alpha(theme.palette.warning.main, 0.02),
                            },
                            "&:nth-of-type(even)": {
                              backgroundColor: alpha(theme.palette.grey[50], 0.5),
                            },
                          }}
                        >
                          <TableCell>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <BallotIcon fontSize="small" sx={{ color: theme.palette.warning.main }} />
                              <Box>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                  {servicio.materiaPrima?.descripcion || "Sin descripción"}
                                </Typography>
                                {generarAtributosSubtexto(servicio.materiaPrima) && (
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{
                                      display: "block",
                                      mt: 0.5,
                                      fontStyle: "italic",
                                      opacity: 0.7,
                                    }}
                                  >
                                    {generarAtributosSubtexto(servicio.materiaPrima)}
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Typography
                              variant="body2"
                              sx={{
                                fontFamily: "monospace",
                                fontWeight: 500,
                                bgcolor: alpha(theme.palette.warning.main, 0.1),
                                px: 1,
                                py: 0.5,
                                borderRadius: 1,
                                display: "inline-block",
                              }}
                            >
                              {servicio.materiaPrima?.codigo || "N/A"}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                              {servicio.cantidad || 0}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {/* Botón de cerrar */}
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
                <Button
                  variant="contained"
                  onClick={handleCloseModalServicios}
                  startIcon={<CloseIcon />}
                  sx={{
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 600,
                    backgroundColor: theme.palette.warning.main,
                    px: 3,
                    "&:hover": {
                      backgroundColor: alpha(theme.palette.warning.main, 0.9),
                    },
                  }}
                >
                  Cerrar
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>

        {/* Modal para editar paquete - GRANDE */}
        <Modal
          open={modalEdicion.open}
          onClose={() => handleCloseModalEdicion()}
          aria-labelledby="modal-edicion-titulo"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "95vw",
              height: "auto",
              maxHeight: "90vh",
              bgcolor: "background.paper",
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
              borderRadius: 3,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header del modal */}
            <Box
              sx={{
                p: 1,
                borderBottom: "1px solid",
                borderColor: "divider",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                bgcolor: alpha(theme.palette.primary.main, 0.05),
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1, minWidth: 0 }}>
                <BallotIcon sx={{ color: theme.palette.primary.main, fontSize: 20, flexShrink: 0 }} />
                <Typography variant="body1" sx={{ fontWeight: 600, fontSize: "0.875rem", flexShrink: 0 }}>
                    Editar Paquete
                  </Typography>
                {modalEdicion.paquete && (() => {
                  // Buscar el item completo en itemTresLetras para obtener los atributos
                  const itemCompleto = itemTresLetras?.find(it => it.id === modalEdicion.paquete.idProductoTerminado)
                  
                  // Formatear atributos
                  let attributeValues = ""
                  if (itemCompleto && itemAtributoNoEliminados) {
                    const activeAttributes = itemAtributoNoEliminados.filter((attr) => !attr.eliminado)
                    attributeValues = activeAttributes
                      .map((attr, index) => {
                        const attributeValue = itemCompleto[`itemDatoAtributo${index + 1}`]
                        return attributeValue ? attributeValue : ""
                      })
                      .filter((val) => val.trim() !== "")
                      .join(" • ")
                  }
                  
                  // Construir el texto completo
                  const nombreGrupo = modalEdicion.paquete.descripcionProductoTerminado || "Sin descripción"
                  const atributosTexto = attributeValues ? ` - ${attributeValues}` : ""
                  const destinoTexto = modalEdicion.paquete.destino ? ` con destino a ${modalEdicion.paquete.destino}` : ""
                  
                  return (
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        color: "text.secondary",
                        ml: 1,
                        flex: 1,
                        minWidth: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {nombreGrupo}{atributosTexto}{destinoTexto}
                    </Typography>
                  )
                })()}
                </Box>
              <IconButton onClick={() => handleCloseModalEdicion()} size="small" sx={{ flexShrink: 0 }}>
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Contenido del modal */}
            <Box
              sx={{
                flex: 1,
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {modalEdicion.paquete && (
                <RecetaComponent
                  modoEdicion={true}
                  paqueteInicial={modalEdicion.paquete}
                  mostrarAnaliticos={true}
                  enModal={true}
                  onGuardadoExitoso={handleRecetaGuardada}
                  onCancelar={handleCloseModalEdicion}
                  ocultarCantidadYCostoXCantidadInicial={modalEdicion.ocultarCantidadYCostoXCantidad}
                />
              )}
            </Box>
          </Box>
        </Modal>

        {/* Modal para editar pasajeros - GRANDE */}
        <Modal
          open={openModalPasajeros}
          onClose={handleCloseModalPasajeros}
          aria-labelledby="modal-pasajeros-titulo"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "95vw",
              height: "90vh",
              bgcolor: "background.paper",
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
              borderRadius: 3,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header del modal */}
            <Box
              sx={{
                p: 1,
                borderBottom: "1px solid",
                borderColor: "divider",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                bgcolor: alpha(theme.palette.primary.main, 0.05),
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <GroupsIcon sx={{ color: theme.palette.primary.main, fontSize: 24 }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "1.1rem" }}>
                    {recetaPasajeros 
                      ? `Gestionar Pasajeros del Paquete - ${recetaPasajeros.destino}`
                      : "Gestionar Pasajeros del Paquete"
                    }
                  </Typography>
                </Box>
              </Box>
              <IconButton onClick={handleCloseModalPasajeros} size="small">
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Contenido del modal */}
            <Box
              sx={{
                flex: 1,
                overflow: "auto",
                p: 1,
              }}
            >
              {recetaPasajeros && recetaPasajeros.grupoFormateado && recetaPasajeros.destinoFormateado && (
                <GestionGenerarClientesPaquete
                  ref={gestionPasajerosRef}
                  grupoInicial={recetaPasajeros.grupoFormateado}
                  destinoInicial={recetaPasajeros.destinoFormateado}
                  modoModal={true}
                  soloLectura={Boolean(recetaPasajeros?.cerrado)}
                  onClose={handleCloseModalPasajeros}
                />
              )}
            </Box>
          </Box>
        </Modal>

        {/* Modal para crear paquete - GRANDE */}
        <Modal
          open={openCrearPaqueteModal}
          onClose={handleCloseCrearPaqueteModal}
          aria-labelledby="modal-crear-paquete-titulo"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90vw",
              height: "90vh",
              bgcolor: "background.paper",
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
              borderRadius: 3,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header del modal */}
            <Box
              sx={{
                p: 2,
                borderBottom: "1px solid",
                borderColor: "divider",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                bgcolor: alpha(theme.palette.primary.main, 0.05),
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1, minWidth: 0 }}>
                <BallotIcon sx={{ color: theme.palette.primary.main, fontSize: 28, flexShrink: 0 }} />
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "1.1rem", flexShrink: 0 }}>
                    Crear Paquete
                  </Typography>
                  {grupoSeleccionadoCrear && (() => {
                    // Buscar el item completo en itemTresLetras para obtener los atributos
                    const itemCompleto = itemTresLetras?.find(it => it.id === grupoSeleccionadoCrear.idItem)
                    
                    // Formatear atributos
                    let attributeValues = ""
                    if (itemCompleto && itemAtributoNoEliminados) {
                      const activeAttributes = itemAtributoNoEliminados.filter((attr) => !attr.eliminado)
                      attributeValues = activeAttributes
                        .map((attr, index) => {
                          const attributeValue = itemCompleto[`itemDatoAtributo${index + 1}`]
                          return attributeValue ? attributeValue : ""
                        })
                        .filter((val) => val.trim() !== "")
                        .join(" • ")
                    }
                    
                    // Construir el texto completo
                    const nombreGrupo = grupoSeleccionadoCrear.descripcion || "Sin descripción"
                    const atributosTexto = attributeValues ? ` - ${attributeValues}` : ""
                    
                    return (
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          color: "rgb(255, 193, 7)", // ✅ Color amarillo RGB
                          fontWeight: 500,
                          mt: 0.5,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {nombreGrupo}{atributosTexto}
                      </Typography>
                    )
                  })()}
                  {!grupoSeleccionadoCrear && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                      Define el grupo base y los servicios del paquete
                    </Typography>
                  )}
                </Box>
              </Box>
              <IconButton onClick={handleCloseCrearPaqueteModal} size="small">
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Contenido del modal */}
            <Box
              sx={{
                flex: 1,
                overflow: "auto",
              }}
            >
              <RecetaComponent
                modoEdicion={false}
                mostrarAnaliticos={true}
                enModal={true}
                onGuardadoExitoso={handlePaqueteCreado}
                onCancelar={handleCloseCrearPaqueteModal}
                ocultarCantidadYCostoXCantidadInicial={paquetesOcultarCantidadFlag}
                onBaseItemChange={setGrupoSeleccionadoCrear} // ✅ Callback para actualizar el grupo seleccionado
              />
            </Box>
          </Box>
        </Modal>
      </Box>
    </ThemeProvider>
  )
}

export default TablaReceta
